import { render, staticRenderFns } from "./ConstructionListPage.vue?vue&type=template&id=684f0156&"
import script from "./ConstructionListPage.vue?vue&type=script&lang=ts&"
export * from "./ConstructionListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports